/* globals getApp  getCurrentPages */
import { reqPathTo } from './env';
import { act } from './navigate.js';
import { request } from './request.js';
import Base from '@baidu/base-util';

/**
 * 获取咨询相关信息
 * @param {String} qcNo 律师的qcNo
 */

export function getConsultInfo(qcNo) {
  let qcCoreNum = qcNo && qcNo.slice(-6) || '';
  const url = reqPathTo('consultinfo', {
    qc_core_num: qcCoreNum,
    vn: 'law'
  }, '', 'falv/lawyer');
  return new Promise(resolve => {
    request({
      url
    }).then(res => {
      let data = res && res.data && res.data.data || {};
      if (!data) {
        resolve({});
        return;
      }
      let {
        target
      } = data || {};
      // 替换成新的支付页面链接
      if (target) {
        data.target = target.replace('/pages/phonechange/index', '/pages/directionalConsult/call');
      }
      resolve({
        consult_service: data
      });
    }).catch(() => {
      resolve({});
    });
  });
}
/**
 *  点击咨询时跳转页面
 * @param {String} qcNo 律师的qcNo
 * @param {Object} urlParams url附加参数
 * @param {Boolean} isOpenPopup 是否自动打开咨询弹窗，目前后端返回的链接是自动打开
 */

export const consultPageChange = (qcNo, urlParams = {}, isOpenPopup = true) => {
  getConsultInfo(qcNo).then(res => {
    let {
      target_url: target
    } = res.consult_service || {};
    if (target) {
      for (let key in urlParams) {
        if (target.indexOf('?') === -1) {
          target += '?';
        }
        if (urlParams[key]) {
          target += `&${key}=${urlParams[key]}`;
        }
      }
      if (!isOpenPopup) {
        target = target.replace(/action=consult/, '');
      }
      act({
        target,
        type: 'url'
      });
    }
  }).catch(() => {});
};

/**
 *  提交咨询请求
 * @param {Object} data
 * @param {Object} data.phone 律师电话
 * @param {Object} data.uk 律师 uk
 * @param {Object} data.title 咨询问题
 * @param {Object} data.type 咨询类型
 */

export const submitConsult = data => {
  const {
    phone = '',
    uk = '',
    title = '',
    type,
    lawyer_phone = '',
    fr = ''
  } = data || {};
  return new Promise((resolve, reject) => {
    request({
      url: reqPathTo('add_consult', {}, '', 'falv/consult1v1'),
      method: 'post',
      data: {
        phone,
        uk,
        title,
        fr,
        lawyer_phone,
        consult_type: type || 1 // 免费预约咨询是1，免费电话咨询是2
      },

      header: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      const data = res && res.data || {};
      if (+data.status !== 0) {
        reject(data);
        return;
      }
      resolve(data);
    }).catch(() => {
      reject();
    });
  });
};